import React from 'react';
import Footer from '../../components/Section/Footer';
import ArticleLayout from '../../components/common/ArticleLayout';

export default function Berita4() {
  return (
    <>
      <ArticleLayout
        title="Game Developer asal Indonesia Jadi Finalis USA Game Award 2025"
        date="30 Mei 2025"
        category="Game Development"
        image="https://www.baker.edu/wp-content/uploads/how-to-become-a-game-developer.jpg"
      >
        <p>
          Sebuah prestasi membanggakan kembali ditorehkan oleh anak bangsa di kancah internasional. Sebuah studio game indie asal Bandung, Indonesia, bernama PixelPlay Studio, resmi diumumkan sebagai salah satu finalis dalam ajang bergengsi USA Game Award 2025. Penghargaan ini merupakan salah satu ajang paling prestisius di industri game global yang mempertemukan talenta-talenta terbaik dari berbagai belahan dunia.
        </p>
        <p>
          Game buatan mereka yang berjudul "Eclipse of Nusantara" berhasil menarik perhatian dewan juri karena memadukan elemen budaya Indonesia dengan gameplay modern berbasis RPG strategi. Tak hanya itu, grafis dan musik latar yang kental dengan nuansa lokal juga menjadi daya tarik tersendiri. PixelPlay Studio menjadi satu-satunya wakil Asia Tenggara yang lolos sebagai finalis tahun ini, bersanding dengan developer dari Amerika Serikat, Kanada, dan Eropa.
        </p>
        <p>
          Menurut CEO PixelPlay, Dimas Arya, perjalanan menuju panggung internasional ini tidak mudah. "Kami memulai dari tim kecil dengan dana terbatas. Tapi semangat untuk memperkenalkan budaya Indonesia ke dunia melalui game membuat kami tidak menyerah," ujarnya. Dimas juga menambahkan bahwa nominasi ini menjadi motivasi besar bagi timnya untuk terus berkarya dan berinovasi.
        </p>
        <p>
          Final USA Game Award 2025 dijadwalkan berlangsung pada bulan September mendatang di San Francisco. Para finalis akan mempresentasikan karya mereka di depan panel juri serta pengunjung dari seluruh dunia. PixelPlay Studio berharap pencapaian ini bisa membuka lebih banyak peluang kolaborasi internasional dan membawa nama Indonesia semakin dikenal dalam dunia pengembangan game global.
        </p>
      </ArticleLayout>

      <Footer />
    </>
  );
}
